import { getApiUrl } from "./config";

/**
 * POST /api/public/vendors/apply: public contractor interest (no auth).
 */
export async function submitVendorApply(payload) {
  const res = await fetch(`${getApiUrl()}/public/vendors/apply`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(data.error || `Request failed (${res.status})`);
  }
  return data;
}
